import 'whatwg-fetch';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Layout } from 'antd';
const { Header, Footer, Content } = Layout;

import { Bridge } from '@nackle/bridge';
import auth from './app-auth.js';

import { Route, routeHistory } from '@nackle/biw-web-router';
import { routes, getMiddleware as getRouteMiddleware } from './app-routing.jsx';

import './styles/app.less';
import '../loader-hatch/styles/file-loader-hatch.less';

class App extends React.Component {
    render() {
        return (
            <Route render={ ( route ) => (
                <Bridge
                    auth={ auth }
                    onSignIn={ this.handleSignIn }
                >
                    <Layout className="root-layout">
                        <Header />
                        <Layout>
                            <Layout className="page-layout">
                                <Content className="app-content">
                                    <div style={ { padding: '24px' } }>
                                        { route.component }
                                    </div>
                                </Content>
                                <Footer />
                            </Layout>
                        </Layout>
                    </Layout>
                </Bridge>
            ) } />
        );
    }

    handleSignIn = async () => {
    };
}

routeHistory.applyRoutes( routes );
routeHistory.applyMiddleware( getRouteMiddleware() );
const root = createRoot( document.getElementById( 'app-root' ) );
root.render( <App /> );